import { Action, Reducer } from "redux";
import { IntegrationState, IntegrationTypes, IntegrationActionTypes } from "./index";

export const INITIAL_STATE: IntegrationState = {
	domain: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	service: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	integrationIntegrationInterfacesByGuidIntegration: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	integrationIntegrationInterface: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	integrationInterface: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const integrationTypeReducer: Reducer<IntegrationState> = (state: IntegrationState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as IntegrationActionTypes;
	switch (actionTypes.type) {
		case IntegrationTypes.GET_DOMAIN:
			return {
				...state,
				domain: { ...state.domain, isLoading: true },
			};
		case IntegrationTypes.SAVE_DOMAIN:
			return {
				...state,
				domain: {
					...state.domain,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationTypes.RESET_REDUCER_DOMAIN:
			return {
				...state,
				domain: INITIAL_STATE.domain,
			};
		case IntegrationTypes.GET_SERVICE:
			return {
				...state,
				service: { ...state.service, isLoading: true },
			};
		case IntegrationTypes.SAVE_SERVICE:
			return {
				...state,
				service: {
					...state.service,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationTypes.RESET_REDUCER_SERVICE:
			return {
				...state,
				service: INITIAL_STATE.service,
			};
		case IntegrationTypes.GET_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES:
			return {
				...state,
				integrationIntegrationInterfacesByGuidIntegration: {
					...state.integrationIntegrationInterfacesByGuidIntegration,
					isLoading: true,
				},
			};
		case IntegrationTypes.SAVE_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES:
			return {
				...state,
				integrationIntegrationInterfacesByGuidIntegration: {
					...state.integrationIntegrationInterfacesByGuidIntegration,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationTypes.RESET_REDUCER_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES:
			return {
				...state,
				integrationIntegrationInterfacesByGuidIntegration:
					INITIAL_STATE.integrationIntegrationInterfacesByGuidIntegration,
			};
		case IntegrationTypes.GET_INTEGRATION_INTEGRATION_INTERFACE:
			return {
				...state,
				integrationIntegrationInterface: {
					...state.integrationIntegrationInterface,
					isLoading: true,
				},
			};
		case IntegrationTypes.SAVE_INTEGRATION_INTEGRATION_INTERFACE:
			return {
				...state,
				integrationIntegrationInterface: {
					...state.integrationIntegrationInterface,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationTypes.RESET_REDUCER_INTEGRATION_INTEGRATION_INTERFACE:
			return {
				...state,
				integrationIntegrationInterface: INITIAL_STATE.integrationIntegrationInterface,
			};
		case IntegrationTypes.GET_INTEGRATION_INTERFACE:
			return {
				...state,
				integrationInterface: { ...state.integrationInterface, isLoading: true },
			};
		case IntegrationTypes.SAVE_INTEGRATION_INTERFACE:
			return {
				...state,
				integrationInterface: {
					...state.integrationInterface,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case IntegrationTypes.RESET_REDUCER_INTEGRATION_INTERFACE:
			return {
				...state,
				integrationInterface: INITIAL_STATE.integrationInterface,
			};
		default:
			return state;
	}
};

export default integrationTypeReducer;
